import React, { createContext, useContext, useEffect, useState } from "react";
import eightAxios from "configs/axiosConfig";
import {
  LOGIN_URL,
  STORAGE_CONSTANT,
  FIRST_TIME_PASSWORD_URL,
  LANGUAGE_URL,
} from "configs/constants";
import { clearLocalStorage, saveLoginInfo } from "utils";
import PropTypes from "prop-types";
import { redirectToLogin } from "utils";
import { useHistory } from 'react-router-dom';
import {checkBOUserStatus} from "../../views/User/BackOfficeUserEditForm"
// /home/decoders/FGV -work evironment/fgv-mta-frontend/src/views/User/BackOfficeUserEditForm.js

const AuthContext = createContext({});


const getAccessToken = localStorage.getItem(STORAGE_CONSTANT.TOKEN); 






const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  let accessToken = localStorage.getItem(STORAGE_CONSTANT.TOKEN);
  const [authLoading, setAuthLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useState(!!accessToken);
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordChange, setPasswordChange] = useState(false);

  useEffect(()=>{
    if(!getAccessToken) {
     // location.reload();
    // redirectToLogin()
    }
  },[!getAccessToken])



  /* To check active status and redirect inactive and deleted users to login page */

   /* function mockUserStatus(userId) {
   // return eightAxios.get(`bo-user/status/${userId}/`)
   return eightAxios.get(`user/getstatus/`) 
    .then(response => {
       if(response.data.status !== "Active") {
            localStorage.clear();
            redirectToLogin();
           }
      })
}
  

 function useUserStatusRedirect() {
  const history = useHistory();

  useEffect(() => {
       const userId = localStorage.getItem('id')

      if (!userId) {
          return;
      }

      const interval = setInterval(async () => {
          const status = await mockUserStatus(userId)
      }, 20000); 

      return () => clearInterval(interval)
  }, []);
} 


  useUserStatusRedirect() */



  const login = (username, password, password1, firstTime) => {
    setErrorMessage("");
    if (!firstTime) {
      if (username.length && password.length) {
        setAuthLoading(true);
        let credentials = new FormData();
        credentials.append("employee_id", username);
        credentials.append("passcode", password);
        eightAxios
          .post(LOGIN_URL, credentials)
          .then((response) => {
            saveLoginInfo(response.data)
              .then(() => {
                setAuthLoading(false);
                setLoggedIn(true);
              })
              .finally(() => {
                location.reload();
              });
            // Reload so that routes will be reloaded again with permission
            location.reload();
          })
          .catch((error) => {
            if (error.response) {
              let errMsg = "";
              for (let key in error.response.data) {
                errMsg += error.response.data[key] + "\n";
                break;
              }
              if (error.response.data && error.response.data.password_change) {
                setPasswordChange(true);
              } else {
                logout();
              }
              setErrorMessage(errMsg);
            } else {
              setErrorMessage(error.message);
              logout();
            }
            setAuthLoading(false);
          });

        const config = {
          params: {
            employee_id: username,
          },
        };
        eightAxios
          .get(LANGUAGE_URL, config)
          .then((response) => {
            localStorage.setItem("locale", response.data.language);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    } else {
      if (username.length && password.length && password1.length) {
        setAuthLoading(true);
        let data = new FormData();
        data.append("password", password);
        data.append("repassword", password1);
        eightAxios
          .post(FIRST_TIME_PASSWORD_URL + username + "/", data)
          .then((response) => {
            saveLoginInfo(response.data)
              .then(() => {
                setAuthLoading(false);
                setLoggedIn(true);
              })
              .finally(() => {
                location.reload();
              });
            // Reload so that routes will be reloaded again with permission
            location.reload();
          })
          .catch((error) => {
            if (error.response) {
              let errMsg = "";
              for (let key in error.response.data) {
                errMsg += error.response.data[key] + "\n";
              }
              setErrorMessage(errMsg);
            } else {
              setErrorMessage(error.message);
            }
            setAuthLoading(false);
            logout();
          });
      }
    }
  };

  // const login = (username, password) => {
  //   setErrorMessage("");
  //   if (username.length && password.length) {
  //     setAuthLoading(true);
  //     let credentials = new FormData();
  //     credentials.append("username", username);
  //     credentials.append("password", password);
  //     eightAxios
  //       .post(LOGIN_URL, credentials, { "Content-Type": "multipart/form-data" })
  //       .then((response) => {
  //         saveLoginInfo(response.data);
  //         setAuthLoading(false);
  //         setLoggedIn(true);
  //         // Reload so that routes will be reloaded again with permission
  //         location.reload();
  //       })
  //       .catch((error) => {
  //         if (error.response) {
  //           let errMsg = "";
  //           for (let key in error.response.data) {
  //             errMsg += error.response.data[key] + "\n";
  //           }
  //           setErrorMessage(errMsg);
  //         } else {
  //           setErrorMessage(error.message);
  //         }
  //         setAuthLoading(false);
  //         logout();
  //       });
  //   }
  // };

  const logout = (redirect = false) => {
    clearLocalStorage().then(() => (redirect ? redirectToLogin() : {}));
  };

  const authValues = {
    authLoading: authLoading,
    setAuthLoading: setAuthLoading,
    loggedIn: loggedIn,
    errorMessage: errorMessage,
    logout: (redirect) => logout(redirect),
    login: (username, password, password1, firstTime) =>
      login(username, password, password1, firstTime),
    setErrorMessage: (msg) => setErrorMessage(msg),
    passwordChange: passwordChange,
  };
  return (
    <AuthContext.Provider value={authValues}>{children}</AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.element,
};

export { AuthProvider, useAuth };
